var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "field",
    _vm._b(
      {
        attrs: {
          "display-name": _vm.condensed ? " " : _vm.displayName,
          "read-only": _vm.readOnly,
          disabled: _vm.disabled,
          "show-label": !_vm.condensed,
        },
      },
      "field",
      { ..._vm.$attrs, ..._vm.$props },
      false
    ),
    [
      _c("label", { staticClass: "gfu-field__toggle gfu-field-toggle" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.model,
              expression: "model",
            },
          ],
          staticClass: "gfu-field-toggle__input",
          attrs: {
            type: "checkbox",
            name: _vm.name,
            disabled: _vm.readOnly || _vm.disabled,
            "data-qa": "checkbox-input",
          },
          domProps: {
            value: _vm.checkedValue,
            indeterminate: _vm.isIndeterminate,
            checked: Array.isArray(_vm.model)
              ? _vm._i(_vm.model, _vm.checkedValue) > -1
              : _vm.model,
          },
          on: {
            change: function ($event) {
              var $$a = _vm.model,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = _vm.checkedValue,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.model = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.model = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.model = $$c
              }
            },
          },
        }),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "gfu-field-toggle__label",
            class: {
              "gfu-field-toggle__label--disabled": _vm.disabled,
              "gfu-field-toggle__label--read-only": _vm.readOnly,
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleState.apply(null, arguments)
              },
            },
          },
          [
            _c("span", {
              staticClass: "gfu-field-toggle__icon",
              class: {
                "gfu-field-toggle__icon--indeterminate": _vm.isIndeterminate,
              },
              attrs: { "data-qa": "checkbox-field-icon" },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "gfu-field-toggle__label-text" }, [
              _c(
                "em",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isRequired,
                      expression: "isRequired",
                    },
                  ],
                },
                [_vm._v("*")]
              ),
              _vm._v(" "),
              _c("span", [
                _c("span", [
                  _vm._v(_vm._s(_vm.condensed ? _vm.displayName : "")),
                ]),
              ]),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }